import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CategoryResponseModel, UpdateCategoryModel } from 'src/app/models/category/addCategory.model';
import { CategoryService } from 'src/app/services/category.service';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';

@Component({
  selector: 'app-update-category',
  templateUrl: './update-category.component.html',
  styleUrls: ['./update-category.component.css']
})
export class UpdateCategoryComponent implements OnInit {
  updateCategory: UpdateCategoryModel;
  getcategorydetails: CategoryResponseModel;
  Loader: boolean = false;
  categoryId: string;
  categorySub: Subscription;
  selectedActiveValue: string;

  constructor(private localstorage: LocalstorageService, private _categoryService: CategoryService, private alertify: AlertifyService,private modalService: NgbModal) { 
    this.localstorage.setMenu("4");
    this.updateCategory = new UpdateCategoryModel();
    this.getcategorydetails = new CategoryResponseModel();
    
  }

  ngOnInit() {
    this.categorySub = this._categoryService.getCategoryId.subscribe((categoryId) => {
      this.categoryId = categoryId;   
    });
    this.getCategoryById();
  }

  onCancel() {
    this.modalService.dismissAll();   
  }
  
  selectActive(selectedValue) {
    this.selectedActiveValue = selectedValue;
  }

  ngOnDestroy() {
    this.categorySub.unsubscribe();
  }

  getCategoryById() {
    this._categoryService.getcategorybyid(this.categoryId).subscribe((response) => {        
      var responseBody = JSON.parse(response._body);
      this.getcategorydetails = responseBody.responseData;
      this.updateCategory.CategoryName = this.getcategorydetails.categoryName;
      this.updateCategory.SearchTags = this.getcategorydetails.searchTags;
      this.updateCategory.IsActive = this.getcategorydetails.isActiveValue; 
      this.selectedActiveValue = this.updateCategory.IsActive ? "1" : "0";          
    });    
  }

  onSubmit() {
    if (this.updateCategory.CategoryName == undefined || this.updateCategory.CategoryName == null || this.updateCategory.CategoryName == "") {
      this.alertify.error("Category Name is required");
      return;
    }
    this.Loader = true;
    this.updateCategory.Id = this.categoryId;
    this.updateCategory.IsActive = this.selectedActiveValue;
    this._categoryService.updateCategory(this.updateCategory).subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.updateCategory = responseBody.responseData;
        this.alertify.success(responseBody.responseMessage);
        this.Loader = false;
        this.modalService.dismissAll();
      } else {
        this.alertify.error(responseBody.responseMessage);
        this.Loader = false;
      }
    });
  }
}
